export default __webpack_public_path__ + "static/media/FOTOS_DISCO_03.e6b291b8.jpg";